export interface DateRangeOption {
  label: string;
  value: string;
}

export const dateRangeObject = {
  anyTime: { label: 'Any time', value: 'any_time' },
  last7Days: { label: 'Last 7 days', value: 'last_7_days' },
  last2Weeks: { label: 'Last 2 weeks', value: 'last_2_weeks' },
  lastMonth: { label: 'Last 30 days', value: 'last_month' },
  lastQuarter: { label: 'Last quarter', value: 'last_quarter' },
  lastYear: { label: 'Last year', value: 'last_year' },
  currentQuarter: { label: 'Current quarter', value: 'current_quarter' },
  currentYear: { label: 'Current year', value: 'current_year' },
  upcoming: { label: 'Upcoming', value: 'upcoming' },
  thisMonth: { label: 'This month', value: 'this_month' },
  previousMonth: { label: 'Previous month', value: 'previous_month' },
  thisQuarter: { label: 'This quarter', value: 'this_quarter' },
  thisYear: { label: 'This year', value: 'this_year' },
  customRange: { label: 'Custom range...', value: 'custom_range' },
} as const;

export const defaultDateRangeList: DateRangeOption[] = [
  dateRangeObject.anyTime,
  dateRangeObject.last7Days,
  dateRangeObject.last2Weeks,
  dateRangeObject.lastMonth,
  dateRangeObject.currentQuarter,
  dateRangeObject.lastQuarter,
  dateRangeObject.currentYear,
  dateRangeObject.lastYear,
  dateRangeObject.customRange,
];

export const evalDateRangeList: DateRangeOption[] = [
  dateRangeObject.anyTime,
  dateRangeObject.upcoming,
  dateRangeObject.thisMonth,
  dateRangeObject.previousMonth,
  dateRangeObject.thisQuarter,
  dateRangeObject.thisYear,
  dateRangeObject.customRange,
];
